import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import BusinessActivateNiudBlockData from '../../../Models/Content/BusinessActivateNiudBlockData';
import BusinessActivateNiudMain from './BusinessActivateNiudMain';

export default class BusinessActivateNiudBlock extends EpiComponent<BusinessActivateNiudBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    return (
      <div>
        <BusinessActivateNiudMain context={this.getContext()} iContent={this.props.data} />
      </div>
    );
  }
}